import React from 'react';
import { Tooltip as RechartsTooltip, DefaultTooltipContent } from 'recharts';

// Строки подсказки идут в том же порядке, что и элементы на графике сверху вниз:
// order='value' (по умолчанию) — по значению по убыванию, пустые в конце;
// order='stack' — вертикальная стопка: верхний сегмент первым (recharts отдаёт серии снизу вверх);
// order='series' — порядок серий как есть (горизонтальная стопка слева направо, полосы-диапазоны).
export const orderPayload = (payload, order = 'value') => {
  if (!Array.isArray(payload) || order === 'series') return payload;
  if (order === 'stack') return [...payload].reverse();
  const num = (v) => (typeof v === 'number' && Number.isFinite(v) ? v : -Infinity);
  return [...payload].sort((a, b) => num(b.value) - num(a.value));
};

const renderContent = (content, props) => {
  if (React.isValidElement(content)) return React.cloneElement(content, props);
  if (typeof content === 'function') return content(props);
  return <DefaultTooltipContent {...props} />;
};

// Подменяет recharts Tooltip во всём проекте: импортируйте Tooltip отсюда, не из 'recharts'.
// order: 'series' — для столбиков рядом (слева направо) и горизонтальных стопок.
// Класс, а не функция: recharts читает defaultProps элемента-подсказки, у функций React 18 на них ругается.
export class Tooltip extends React.PureComponent {
  // recharts находит подсказку среди детей графика по displayName
  static displayName = 'Tooltip';

  static defaultProps = { ...RechartsTooltip.defaultProps, order: 'value' };

  render() {
    const { content, order, ...rest } = this.props;
    return (
      <RechartsTooltip
        {...rest}
        itemSorter={null}
        content={(props) => renderContent(content, { ...props, payload: orderPayload(props.payload, order) })}
      />
    );
  }
}
